import React, { Component } from "react";
import _ from 'lodash';
import SearchWorkItem from './SearchWorkItem'
import {Modal} from 'react-bootstrap';
export default class DoubleScreen  extends Component {
  render(){     
    let auditorJson = {'templateValue':this.props.auditorJSON}
    let fieldValue = _.cloneDeep(this.props.object)
    let arrayobj=[];    
    delete fieldValue.id
    arrayobj.push(
      {'label':'Auditor Name', 'value': fieldValue.auditorName},
      {'label':'Audited Date', 'value': fieldValue.updated_date},
      {'label':'Mobile number', 'value': fieldValue.msisdn},
      {'label':'Region', 'value': fieldValue.regionName},
      {'label':'Center', 'value': fieldValue.centerName},
      {'label':'Client', 'value': fieldValue.clientName}, 
      {'label':'Process', 'value': fieldValue.processName},
      {'label':'Tenure', 'value': fieldValue.tenure},
      {'label':'Call Sub Type1', 'value': fieldValue.callSubType1},
      {'label':'Call Sub Type2', 'value': fieldValue.callSubType2},
      {'label':'Call Sub Type3', 'value': fieldValue.callSubType3},
      {'label':'Call Sub Type4', 'value': fieldValue.callSubType4},
      {'label':'Case Type', 'value': fieldValue.caseType},
      {'label':'TL Name', 'value': fieldValue.tlName},
      {'label':'Skill Set', 'value': fieldValue.skillSetName})

    return(
      <Modal
      show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w"
      size="xl"
     //aria-labelledby="contained-modal-title-vcenter"
      centered
      >
      <Modal.Header closeButton>
      <Modal.Title id="example-custom-modal-styling-title">
        {"Evaluation Form For --"+fieldValue.regionName+'/'+fieldValue.centerName+'/'+fieldValue.clientName+'/'+fieldValue.processName}
               
        </Modal.Title>       
      </Modal.Header>
      <Modal.Body><SearchWorkItem auditorJson={auditorJson} fieldValue = {arrayobj} loginUserName={this.props.loginUserName}
        status={fieldValue.status} ScoreCalculation={this.props.ScoreCalculation}
        action={this.props.action} closeModal={this.props.closeModal} id={this.props.object.id} /></Modal.Body>
      </Modal>

    )
  }
}